import { useEffect, useState } from 'react';
import { ArrowPathIcon } from '@heroicons/react/20/solid';
import { ProgressBar } from "../../../components/progressbar/ProgressBar";

export const DiorRecalibration = ({ hasDoubt = false, compact = false }) => {
  const FIRST_STEP_DURATION = 5;
  const [progress, setProgress] = useState(0);
  const [showSecondMessage, setShowSecondMessage] = useState(false);

  useEffect(() => {
    if (!hasDoubt) {
      setProgress(0);
      setShowSecondMessage(false);
      return;
    }

    setProgress(0);
    setShowSecondMessage(false);

    const interval = setInterval(() => {
      console.log('interval');
      setProgress((currentProgress) => Math.min(currentProgress + 100 / FIRST_STEP_DURATION, 100));
    }, 1000);

    const timeout = setTimeout(() => {
      clearInterval(interval);
      setShowSecondMessage(true);
    }, (FIRST_STEP_DURATION + 1) * 1000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [hasDoubt]);

  return (
    <div className={`absolute ${hasDoubt ? 'opacity-100' : 'opacity-0'} transition-all pointer-events-none top-0 left-0 w-full h-full z-20 bg-black/40 backdrop-blur flex justify-center items-center`}>
      <div className={`bg-perception-black-700 flex flex-col items-center justify-center text-center rounded-md ${compact ? 'w-full max-w-[800px] max-h-full overflow-y-auto px-6 py-3 gap-2 text-lg' : 'w-[800px] py-16 pt-24 gap-8 text-2xl'}`}>
        <p>O sistema de IA pode estar incerto quanto à posição dos racks.</p>
        <ArrowPathIcon className={`${compact ? 'size-9' : 'size-16'} animate-spin`}/>
        <div className={`flex flex-col ${compact ? 'gap-2' : 'gap-4'}`}>
          {
            showSecondMessage ?
              <p>A próxima ação na linha recalibrará o sistema.</p> :
              <p>Recalibração do sistema em andamento...</p>
          }
          <ProgressBar
            value={progress} color="bg-perception-blue" durationClass="duration-1000" bgColor="bg-perception-black-500" size="sm"
            className={`${showSecondMessage ? 'opacity-0' : ''}`}
          />
        </div>
      </div>
    </div>
  );
};